import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "../ReportIncome.module.css";
import moment from "moment";
import { fetchPracticeIncome, fetchGraphPracticeIncome } from "../../../redux";
import { fetchpractitioner } from "../../../redux";
import { Field, Form, Formik } from "formik";
import { DatePicker } from "antd";
import * as Yup from "yup";
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Card,
    Button,
    CardTitle,
    CardText,
    Row,
    Col,
} from "reactstrap";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { Select } from "antd";
import CustomCharts from "../../../containers/CustomCharts";
import { checkIfPermitted, Permissions } from "../../../services/RolePermissionService";
import { formatNumberToCurrency } from "../../../utils/CommonUtil";

const { Option } = Select;


function dateFormatter(cell) {
    if (!cell) {
        return "";
    }
    return `${
        moment(cell).format("YYYY-MM-DD")
            ? moment(cell).format("YYYY-MM-DD")
            : moment(cell).format("YYYY-MM-DD")
        }`;
}
//const weeks = ["Mon","Tue","Wed","Thur","Fri","Sat","Sun"];
const weeks = [{
    key: "Mon",
    day: "Monday"
}, {
    key: "Tue",
    day: "Tuesday"
}, {
    key: "Wed",
    day: "Wednesday"
}, {
    key: "Thur",
    day: "Thursday"
}, {
    key: "Fri",
    day: "Friday"
}, {
    key: "Sat",
    day: "Saturday"
}, {
    key: "Sun",
    day: "Sunday"
}];


export class PracticeIncome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            sortName: "",
            sortOrder: "",
            sortBy: "",
            isDataFetched: false,
            practiceIncome: [],
            graphDataPracticeIncome: [],
            income_type: "currentPastIncome",
            view_by: "month",
            practitioner_id: "",
            practitioner_name: "",
        };
        this.setLoader = this.setLoader.bind(this);
    }

    componentDidMount = async () => {
        this.props.fetchGraphPracticeIncome(this.state.view_by, this.state.practitioner_id);
        await this.props.fetchpractitioner(this.state.practitioner_name);
        await this.props.fetchPracticeIncome(this.state.sortBy, this.state.page, this.state.view_by,
            this.state.practitioner_id);

        if (this.props.practiceIncomeData &&
            this.props.practiceIncomeData.practiceIncome &&
            this.props.practiceIncomeData.practiceIncome.payment) {
            this.setState({
                practiceIncome: this.props.practiceIncomeData.practiceIncome.payment
            })
        }
        
        if (this.props.graphDataPracticeIncomeData &&
            this.props.graphDataPracticeIncomeData.graphDataPracticeIncome &&
            this.props.graphDataPracticeIncomeData.graphDataPracticeIncome.payment) {
            this.setState({
                graphDataPracticeIncome: this.props.graphDataPracticeIncomeData.graphDataPracticeIncome.payment
            })
        }
        setTimeout(() => {
            if (!this.props.practiceIncomeData.loading || (this.props.practiceIncomeData.practiceIncome.total === 0)) {
                this.setState({
                    isDataFetched: true,
                });
            } else {
                this.setState({
                    isDataFetched: false,
                });
            }
        }, 1000);

        //Updating parent state for export filters
        let parentPayload = {
            sortBy: this.state.sortBy,
            view_by: this.state.view_by,
            practitioner_id: this.state.practitioner_id
        }
        this.props.updateParentState(parentPayload);
    }

    callPracticeIncomeAPI = async () => {
        this.props.fetchGraphPracticeIncome(this.state.view_by, this.state.practitioner_id);
        this.setState({
            practiceIncome: []
        })
        await this.props.fetchPracticeIncome(this.state.sortBy, this.state.page, this.state.view_by,
            this.state.practitioner_id);

        if (!this.props.practiceIncomeData.loading) {
            this.setState({
                practiceIncome: this.props.practiceIncomeData.practiceIncome.payment
            })
            setTimeout(() => {
                this.setState({
                    isDataFetched: true,
                });
            }, 500);
        }

        //Updating parent state for export filters
        let parentPayload = {
            sortBy: this.state.sortBy,
            view_by: this.state.view_by,
            practitioner_id: this.state.practitioner_id
        }
        this.props.updateParentState(parentPayload);

    }


    handleOptionChange = (event) => {
       // console.log("event", event);
        this.setState({
            income_type: event.target.value,
        });
    };

    onSortChange = (sortName, sortOrder) => {
        let sortBy;
        if (sortOrder == "desc") {
            sortBy = "-" + sortName;
        } else {
            sortBy = sortName;
        }
        this.setState({
            sortName,
            sortOrder,
            sortBy,
            page: 1,
            isDataFetched: false,
        }, () => {
            this.callPracticeIncomeAPI();
        });

    };

    onSearchChange = (event) => {
        this.setState({
            searchKey: event.target.value,
            page: 1,
            isDataFetched: false
        }, () => {
            this.callPracticeIncomeAPI();
        });

    };

    onPageChange = (page, sizePerPage) => {
        this.setState({
            page,
            isDataFetched: false
        }, () => {
            this.callPracticeIncomeAPI();
        });
    };


    handleInputChange = (event) => {
        let filterval = event.target.value;

        this.setState({
            view_by: filterval,
            page: 1,
            isDataFetched: false
        }, () => {
            this.callPracticeIncomeAPI();
        })
    }


    /**
     * This method will be called when there is not data or data is being fetched to show the loader.
     */
    setLoader() {
        if (this.state.isDataFetched) {
            return <p>There is no data to display</p>;
        } else {
            return (
                <div>
                    <img src={ttmLoader} alt='loader' className="loader-image" />
                </div>
            );
        }
    }

    /**
    * This method will be called to format the table data for valid data.
    * @param {string} data of the table column.
    * @returns {string} data or Not available string
    */
    checkValidData = (data) => {
        if (!data) {
            return "Not Available";
        } else {
            return data;
        }
    }

    /**
    * This method will be called to format the table data for valid data.
    * @param {string} data of the table column.
    * @returns {string} data with first letter capital or Not available string
    */
    detailFormatter = (data) => {
        if (!data) {
            return "Not Available";
        } else {
            return data ? (data.charAt(0).toUpperCase() + data.slice(1)) : "Not Available";
        }
    }

    /**
     * This method will clear all the filters which are selected.
     */
    handleClearFilters = () => {
        this.setState({
            page: 1,
            sortName: "",
            sortOrder: "",
            sortBy: "",
            view_by: "month",
            practitioner_id: "",
            income_type: "currentPastIncome",
            isDataFetched: false
        }, () => {
            this.callPracticeIncomeAPI();
        })
    }

    onChangePratitioner = (value) => {
        console.log(`selected ${value}`);
        this.setState({
            practitioner_name: value,
            practitioner_id: value,
            isDataFetched: false,
            page:1
        }, () => {
            this.callPracticeIncomeAPI();
        });
    };

    onSearchPratitioner = (val) => {
        // Calling practitioner autocomplete data
        this.props.fetchpractitioner(val);
        this.setState({
            practitioner_name: val,
        });
    };

    /**
    * This will return filter form HTML for the render method.
    */
    getPatientFilter = () => {

        const practitionerOptions =
            this.props.practitionerData && this.props.practitionerData.practitioner;

        return (
            <div className={`row `}>
                <div className="col-md-3">
                    <label>Practitioner Name</label>
                    <Select
                        showSearch
                        allowClear={true}
                        name="practitioner_name"
                        placeholder="Search Practitioner"
                        optionFilterProp="children"
                        onChange={this.onChangePratitioner}
                        onSearch={this.onSearchPratitioner}
                        filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                        }
                        value={this.state.practitioner_id}
                        disabled={this.state.isDisabled}
                    >
                        {practitionerOptions &&
                            practitionerOptions.map((element, index) => (
                                <Option key={index} value={element.practitioner_id}>
                                    {element.practitioner_name}
                                </Option>
                            ))}
                    </Select>
                </div>
                <div className="col-md-7">
                    <label>Income Type</label>
                    <div>
                        <div className="custom-control custom-radio custom-control-inline">
                            <input
                                type="radio"
                                className="custom-control-input"
                                id="currentPastIncome"
                                name="income_type"
                                value="currentPastIncome"
                                checked={this.state.income_type === "currentPastIncome"}
                                onChange={this.handleOptionChange}
                            />
                            <label className="custom-control-label" htmlFor="currentPastIncome">
                                Current/Past Income
                    </label>
                        </div>
                        {checkIfPermitted(Permissions.REPORT_PRACTICE_PROJECTED_INCOME) && (
                        <div className="custom-control custom-radio custom-control-inline">
                            <input
                                type="radio"
                                className="custom-control-input"
                                id="projectedIncome"
                                name="income_type"
                                value="projectedIncome"
                                checked={this.state.income_type === "projectedIncome"}
                                onChange={this.handleOptionChange}
                            />
                            <label className="custom-control-label" htmlFor="projectedIncome">
                                Projected Income
                    </label>
                        </div>)}
                    </div>
                </div>

                <div className="col-md-2">
                    <div className="form-group">
                        <label htmlFor="adh_payer_accType">
                            View by
                        </label>
                        <select
                            className="form-control"
                            id="view_by"
                            name="view_by"
                            onChange={this.handleInputChange}
                            value={this.state.view_by}
                        >
                            <option value="month">Month</option>
                            <option value="week">Week</option>
                        </select>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const practiceIncomeData = this.props.practiceIncomeData.practiceIncome;
       // console.log("graphData", this.props.graphDataPracticeIncomeData.graphDataPracticeIncome);
        const graphData =  this.props.graphDataPracticeIncomeData.graphDataPracticeIncome;

        const PracticeIncomeGrapData = {
            labels: [],
            series: []
        }
        let array = [];
        graphData.forEach(element => {
            if(this.state.view_by === "week"){
                PracticeIncomeGrapData.labels.unshift(element.dayName);
            }else {
                PracticeIncomeGrapData.labels.unshift(moment(element.created_at).format("Do MMM"));
            }
            array.unshift(element[`SUM(amount)`]);
        });
        PracticeIncomeGrapData.series.push(array);

       // console.log("PracticeIncomeGrapData", PracticeIncomeGrapData);

        return (
            <div className={`inventory-tab-wrapper flex-wrap`}>
                <div className="row">
                <div className="col-md-12 d-flex justify-content-md-end">
                        <a className="clearFilters"
                            href="javascriptVoid:0"
                            onClick={this.handleClearFilters}>
                            Clear Filters
                        </a>
                    </div>
                    <div className="col-md-12">
                        {this.getPatientFilter()}
                    </div>
                </div>

                <div className="row Practice-Income">
                    <div className={`col-md-6`}>
                        <div className={`custom-border-box `}>
                            <BootstrapTable
                                bordered={false}
                                remote={true}
                                data={this.state.practiceIncome}
                                version="4"
                                search={false}
                                pagination
                                fetchInfo={{
                                    dataTotalSize: practiceIncomeData.total,
                                }}
                                options={{
                                    searchvalue: "",
                                    sortName: this.state.sortName,
                                    sortOrder: this.state.sortOrder,
                                    onSortChange: this.onSortChange,
                                    // onSearchChange: this.onSearchChange,
                                    sizePerPage: 10,
                                    page: this.state.page,
                                    onPageChange: this.onPageChange,
                                    noDataText: this.setLoader(),
                                }}>
                                <TableHeaderColumn
                                    dataField="created_at"
                                    isKey={true}
                                    dataFormat={dateFormatter}
                                    dataSort={true}
                                    width="20%"
                                >
                                    Date
                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField="dayName"
                                    dataSort={true}
                                    width="20%"
                                >
                                    Day
            </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField="amount"
                                    dataSort={true}
                                    dataFormat={formatNumberToCurrency}
                                    width="20%"
                                >
                                    Income(ZAR)
            </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="custom-border-box">
                            <label className="mt-1">{this.state.income_type === "currentPastIncome"?"Current/Past Income":"Projected Income"}</label>
                           {!this.props.graphDataPracticeIncomeData.loading ? (
                                <CustomCharts data={PracticeIncomeGrapData} indicator={"Income"} />
                           ):(
                            <div className="dashboard-loader">
                                <img src={ttmLoader} alt='loader' className="loader-image" />
                            </div>
                        )}
                        </div>
                </div>
                </div>
            </div>);
    }
}

// export default Users;
const mapStateToProps = (state) => {
    return {
        practiceIncomeData: state.practiceIncome,
        practitionerData: state.practitioner,
        graphDataPracticeIncomeData: state.graphDataPracticeIncome
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchPracticeIncome: (sortBy, page, view_by, practitioner_id) => dispatch(fetchPracticeIncome(sortBy, page, view_by, practitioner_id)),
        fetchGraphPracticeIncome: (view_by, practitioner_id) => dispatch(fetchGraphPracticeIncome(view_by, practitioner_id)),
        fetchpractitioner: (practitionerName) => dispatch(fetchpractitioner(practitionerName)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PracticeIncome);
